var map = {
	"./ARDOISE_SD.jpg": 24,
	"./flags/be.svg": 25,
	"./flags/cn.svg": 26,
	"./flags/de.svg": 27,
	"./flags/es.svg": 28,
	"./flags/fr.svg": 29,
	"./flags/gb.svg": 30,
	"./flags/it.svg": 31,
	"./flags/jp.svg": 32,
	"./flags/us.svg": 33,
	"./icons/back.svg": 34,
	"./icons/close.svg": 35,
	"./icons/error.svg": 36,
	"./icons/facebook.svg": 37,
	"./icons/info.svg": 38,
	"./icons/instagram.svg": 39,
	"./icons/linkedin.svg": 40,
	"./icons/marker.svg": 41,
	"./icons/slider-arrow.svg": 42,
	"./icons/success.svg": 43,
	"./icons/tiktok.svg": 44,
	"./icons/twitter-x.svg": 45,
	"./icons/twitter.svg": 46,
	"./icons/weibo.svg": 47,
	"./icons/whatsapp.svg": 48,
	"./icons/youtube.svg": 49,
	"./logo.png": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;